var _path, _path2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0027 16.4767C9.74161 16.4579 7.51299 15.9362 5.47812 14.9496C3.44331 13.9631 1.65351 12.536 0.238528 10.7722L0 10.4462L0.238528 10.1201C1.65403 8.35717 3.44386 6.93108 5.47846 5.94543C7.51326 4.95957 9.74158 4.43886 12.0024 4.42062C14.2625 4.43951 16.4901 4.96063 18.5236 5.94649C20.5573 6.93221 22.3465 8.35775 23.7615 10.1201L24 10.4462L23.7615 10.7724V10.7722C22.347 12.5356 20.558 13.962 18.5243 14.9486C16.4904 15.9351 14.2629 16.4571 12.0024 16.4766L12.0027 16.4767ZM1.39705 10.4461C2.37047 11.5948 6.10349 15.3716 12.0027 15.3716C17.9016 15.3716 21.6203 11.5995 22.6084 10.4509C21.6156 9.28744 17.902 5.52503 12.0027 5.52503C6.10383 5.52503 2.38517 9.28723 1.39705 10.4458V10.4461Z",
    fill: "#A5A5A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0027 13.5565C11.1783 13.5616 10.3858 13.2388 9.79954 12.659C9.21345 12.0793 8.88184 11.2903 8.87796 10.4659C8.87408 9.64145 9.19819 8.84941 9.7789 8.26412C10.3595 7.67885 11.149 7.34858 11.9735 7.34604C12.7978 7.34336 13.5895 7.66868 14.1738 8.25033C14.7582 8.83186 15.0872 9.62191 15.0886 10.4464C15.0886 11.267 14.7642 12.0543 14.1862 12.637C13.6083 13.2195 12.8234 13.5501 12.0027 13.5565ZM12.0027 8.44583C11.4708 8.44583 10.9608 8.65717 10.5848 9.03325C10.2087 9.40933 9.99737 9.91934 9.99737 10.4512C9.99737 10.983 10.2087 11.493 10.5848 11.8691C10.9609 12.2451 11.4709 12.4565 12.0027 12.4565C12.5345 12.4565 13.0447 12.2451 13.4206 11.8691C13.7967 11.493 14.008 10.983 14.008 10.4512C14.008 9.91931 13.7967 9.4093 13.4206 9.03325C13.0446 8.65717 12.5345 8.44583 12.0027 8.44583Z",
    fill: "#A5A5A5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.12417,
    y1: 1,
    x2: 20.5234,
    y2: 18.3992,
    stroke: "#A5A5A5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDisabled);
export default __webpack_public_path__ + "static/media/eye-disabled.0262bb7f81763b5a09b6281661043d5e.svg";
export { ForwardRef as ReactComponent };